export function buildCustomerSavePayload({ formFields, editedFields, isRoyaltyValue, isEditorAccess, selectedEditors, selectedGroups, passwordEdited }) {
  const fields = {
    firstname: formFields.firstname,
    lastname: formFields.lastname,
    business_name: formFields.business_name,
    phone: formFields.phone,
    email: formFields.email,
    address: formFields.address,
    royalty_only: isRoyaltyValue,
    assigned_editors: isEditorAccess.value === 'admin' ? [] :
      isEditorAccess.value === 'all_editors' ? ['all'] :
        selectedEditors?.id ? [String(selectedEditors.id)] : [],
    groupIds: selectedGroups.map((group) => group.id),
  };
  const payload = formFields.id
    ? { id: formFields.id, ...Object.fromEntries(
      [...editedFields].filter((key) => key in fields).map((key) => [key, fields[key]])
    ) }
    : fields;
  if ((!formFields.id || editedFields.has('username')) && formFields.username) {
    payload.username = formFields.username;
  }
  if (formFields.password && (!formFields.id || passwordEdited)) {
    payload.password = formFields.password;
  }
  return payload;
}

export function buildPlaylistSavePayload({ id, originalSongIds, songs, originalName, name, originalType, type }) {
  if (!id || !Array.isArray(originalSongIds) || !Array.isArray(songs)) {
    throw new Error('Playlist is still loading. Please try again.');
  }
  const songIds = songs.map((song) => song.id);
  const songsChanged = songIds.length !== originalSongIds.length ||
    songIds.some((songId, index) => songId !== originalSongIds[index]);
  return {
    id,
    ...(originalName !== undefined && name !== originalName ? { name } : {}),
    ...(originalType !== undefined && type !== originalType ? { type } : {}),
    ...(songsChanged ? {
      songs: songIds.map((songId, index) => ({ id: songId, index })),
      expectedSongIds: originalSongIds,
    } : {}),
  };
}

export function playlistTypeForSave(originalType, isRoyalty) {
  return originalType === 3 || originalType === 4 ? (isRoyalty ? 3 : 4) : originalType;
}
